module.exports = __webpack_public_path__ + "static/business-modeling-splash.2ee7b659.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/img/business-modeling-splash.jpeg
// module id = 873
// module chunks = 101846417399083